import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AmdocsEventBusService } from 'amdocs-core-package';
import { CONSTANTS } from 'src/app/constants';
import { EligibilityService } from 'src/app/service/eligibility.service';
import { TitleService } from 'src/app/service/title.service';
import { UserService } from 'src/app/service/user.service';
import { CommonModule } from '@angular/common';
import { PermissionComponent } from 'src/app/shared/permission-issue/permission-issue.component';
import { AppServices } from '../../service/app.service';
@Component({
  selector: 'app-accessDeenied',
  templateUrl: './accessDenied.component.html',
  standalone: true,
  imports: [CommonModule, PermissionComponent]
})
export class AccessDeniedComponent implements OnDestroy, OnInit{

  constructor(private eventBus: AmdocsEventBusService,private router: Router,private userService:UserService,private eligibilityService:EligibilityService,private titleService:TitleService,private appServices:AppServices) {
     this.eventBus.emit(CONSTANTS.EVENTS.APP_LOADED,true);
     this.eventBus.emit(CONSTANTS.EVENTS.IS_FIXED_FOOTER,true);
     this.checkisEligible();
  }

  ngOnInit() : void{
    this.setTitle();
  }

  checkisEligible() : void {
    const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
        if (navigation.type == 'reload') {
          let userData= {
            "SO_Session_ID": sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID)?sessionStorage.getItem(CONSTANTS.SessionSTORAGE.SOSessionID):'',
            "User_ID": this.userService.getEmail(),
            "IP_Details": "",
            "Emp_ID": this.userService.getEmployeeCode(),
            "DaC_Session_ID": ""
          }
    let statsdata={
      actionType:CONSTANTS.STATISTICS.EligibilityActivity,
      eventType:'AccessDeniedEligibilityCheck'
    }
    const userStatsData=this.userService.getStatsticsInput(statsdata);    
      this.eligibilityService
      .getEligibility(userData,userStatsData)
      .subscribe((eligible) => {
        if(eligible?.getEligibilityRuleFromAPS?.params['IsEligible']){
          localStorage.setItem(CONSTANTS.STORAGE.isProductLine,'1');
          localStorage.setItem(CONSTANTS.STORAGE.userEligibility,'true');
          this.getNotification();
          this.router.navigate(['/']);
          }
      }); 
      
    }
  }

   getNotification(): void {
    // Call notification service for eligible users
     this.appServices.systemNotificationService.getUserDACNotifications().subscribe({
        next: (notificationResponse: any) => {
          console.log('Notifications received for eligible user:', notificationResponse);
          
          // Check if notifications exist and process active ones
          if (notificationResponse?.getUserDACNotifications?.length > 0) {
            const notifications = notificationResponse.getUserDACNotifications;
            
            // Find first active notification
            const activeNotification = notifications.find((notification: any) => notification.u_active === "true");
            
            if (activeNotification && activeNotification.u_message && activeNotification.u_message.trim() !== '') {
              this.eventBus.emit('showNotification', {
                'message': activeNotification.u_message,
                'sys_id': activeNotification.sys_id
              });
            }
          }
        },
        error: (notificationError: any) => {
          console.error('Error fetching notifications:', notificationError);
        }
      });
   }

  setTitle(): void {
    const staticTitle = CONSTANTS.PageTitle['AccessDeniedPage']; // Set your static title here
    this.titleService.setTitle(staticTitle);
  }

  ngOnDestroy(): void {
    this.eventBus.emit(CONSTANTS.EVENTS.IS_FIXED_FOOTER,false);
  }
  
}
